import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import TableBoolean from '../../components/Table/TableBoolean/TableBoolean';
import { modifyToInstance } from '../../lib/Formatter';

const headerStyle = () => {
    return { borderColor: '#a81933' };
};

const columnStyle = () => {
    return {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    };
};

export const ClassTypeEnum = {
    AllInstances: 163,
    Corporate: 164,
    NonCorporate: 165
}

export const columns = [
    {
        dataField: 'ClassStatus.Name',
        text: 'Status',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle,
        formatter: (_cell, row) => <TableBoolean value={row.ClassStatus.Id === 1} text={row.ClassStatus.Name} />,
    },
    {
        dataField: 'Course.Name',
        text: 'Course',
        sort: true,
        headerStyle: headerStyle,
        style: { ...columnStyle, width: '100%' }
    },
    {
        dataField: 'Course.CourseNumber',
        text: 'Course Number',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle
    },
    {
        dataField: 'StartTime',
        text: 'Start Time',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle,
        formatter: (_cell, row) => {
            return moment(row.StartTime).format('MM/DD/YYYY h:mm A')
        }
    },
    {
        dataField: 'EndTime',
        text: 'End Time',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle,
        formatter: (_cell, row) => {
            return moment(row.EndTime).format('MM/DD/YYYY h:mm A')
        }
    },
    {
        dataField: 'ClassType',
        text: 'Class Type',
        sort: true,
        headerStyle: headerStyle,
        style: { ...columnStyle, whiteSpace: 'normal' },
        formatter: (_cell, row) => {
            return !_.isEmpty(row.ClassType)
                ? row.ClassTypeId === ClassTypeEnum.AllInstances
                    ? 'Corporate Instances, Non-Corporate Instances'
                    : modifyToInstance(row.ClassType.Name)
                : 'Not Selected';
        }
    }
];

export const sorting = [{
    dataField: 'StartTime',
    order: 'asc'
}];